import React, { useState } from "react";
import { Helmet } from "react-helmet";
import axios from 'axios'; // Import Axios
import config from "../includes/ConfigFile";

const Contact = ({ company }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [enquiry, setEnquiry] = useState("");

    const [submissionSuccess, setSubmissionSuccess] = useState(false);

    const collectData = async () => {
        try {
            const data = { name, email, phone, enquiry }; 
            const result = await axios.post(`${config.BASE_URL}/api/enquiry`, data, {
                headers: { "Content-Type": "application/json" } 
            });
    
            if (result.status === 200) {
                setSubmissionSuccess(true); 
                resetForm(); 
            } else {
                setSubmissionSuccess(false); 
            }
        } catch (error) {
            console.error("There was an error submitting the form:", error);
            setSubmissionSuccess(false); 
        }
    };

    const resetForm = () => {
        setName("");
        setEmail("");
        setPhone("");
        setEnquiry("");
    };

    const style = {
        padding: '10px',
        width: '100%',
        height: '300px'
    };

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Contact Us Page | Get in Touch</title>
                <link rel="canonical" href="http://mysite.com/example" />
                <meta name="description" content="Contact us for any questions or support                                    " />
            </Helmet>
            <div className="contact-hero py-5 bg-light">
                <div className="container text-center">
                    <h1 className="display-4 mb-3">Get in Touch</h1>
                    <p className="lead text-muted">We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
                </div>
            </div>
            <div className="container py-5">
                <div className="row g-5">
                    <div className="col-lg-4">
                    <div className="contact-info p-4 bg-white shadow-sm rounded">
                            <div className="info-item mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-geo-alt fs-4 text-primary me-3"></i>
                                    <h5 className="mb-0 contactUsTitle">Visit Us</h5>
                                </div>
                                <p className="text-muted mb-0">
                                    {company.address}
                                </p>
                            </div>

                            <div className="info-item mb-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-envelope fs-4 text-primary me-3"></i>
                                    <h5 className="mb-0 contactUsTitle">Email Us</h5>
                                </div>
                                <p className="text-muted mb-0">{company.email}</p>
                            </div>

                            <div className="info-item">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-telephone fs-4 text-primary me-3"></i>
                                    <h5 className="mb-0 contactUsTitle">Call Us</h5>
                                </div>
                                <p className="text-muted mb-0">+{company.phone_first}<br />+{company.phone_second}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8">
                        

                        <div className="contact-form p-4 bg-white shadow-sm rounded">

                            {/* Conditionally render success message based on submissionSuccess */}
                            {submissionSuccess && (
                                <div className="alert alert-success alert-dismissible fade show" role="alert">
                                    <i className="bi bi-check-circle me-2"></i>
                                    Thank you for your message! We'll get back to you soon.
                                    <button type="button" className="btn-close" onClick={() => setSubmissionSuccess(false)}></button>
                                </div>
                            )}

                            <form className="row g-3">
                                <div className="col-md-6">
                                    <label htmlFor="name" className="form-label contactUsTitle">Full Name</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        id="name" 
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="John Doe"
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label htmlFor="email" className="form-label contactUsTitle">Email Address</label>
                                    <input 
                                        type="email" 
                                        className="form-control" 
                                        id="email" 
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        placeholder="john@example.com"
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="phone" className="form-label contactUsTitle">Phone Number</label>
                                    <input 
                                        type="tel" 
                                        className="form-control" 
                                        id="phone" 
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        placeholder="+91 98765 43210"
                                    />
                                </div>

                                <div className="col-12">
                                    <label htmlFor="enquiry" className="form-label contactUsTitle">Your Message</label>
                                    <textarea 
                                        className="form-control" 
                                        id="enquiry" 
                                        rows="5"
                                        value={enquiry}
                                        onChange={(e) => setEnquiry(e.target.value)}
                                        placeholder="How can we help you?"
                                    ></textarea>
                                </div>

                                <div className="col-12">
                                    <button 
                                        type="button" 
                                        className="btn btn-primary btn-lg"
                                        onClick={collectData}
                                    >
                                        Send Message
                                    </button>
                                </div>
                            </form>

                        </div>

                    </div>
                </div>
                <div className="container-fluid p-0">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.8607342384707!2d72.8322448746103!3d19.157572449407724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b6446eae1cfb%3A0x6594c1338d2ded83!2sHarmony%20Mall%2C%20New%20Link%20Rd%2C%20Sejal%20Park%2C%20Colony%20No%201%2C%20Bhagat%20Singh%20II%2C%20Goregaon%20West%2C%20Mumbai%2C%20Maharashtra%20400104!5e0!3m2!1sen!2sin!4v1748179112652!5m2!1sen!2sin"
                        style={style}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    >
                    </iframe>
                    
                </div>
            </div>
        </>
    );
}

export default Contact;
